import { createSelector } from "@ngrx/store";
import { AppState } from "../../core/store/core.state";

export const courseState = (state: AppState) => state.course;

export const getCoursesSelector = createSelector(
  courseState,
    (state) => state.courseList
);

export const getCurrentCourseSelector = createSelector(
  courseState,
  (state) => state.currentCourse
);

export const getCourseModulesSelector = createSelector(
  courseState,
  (state) => state.currentCourse.courseModules
);

